import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import VgtSetMeterRequest from "../VgtSetMeterRequest";
import ModelProxyClass from "./ModelProxyClass";


/**
 * @class VgtSetMeterRequestBase
 * @extends ModelBaseClass
 * @property {number} cashAccountId (int64) ID of the VGT Meter CashAccount to set/update the Soft Meter to
 * @property {number} newMeterAmount
 */
class VgtSetMeterRequestBase extends ModelBaseClass {
	/**
	 * ID of the VGT Meter CashAccount to set/update the Soft Meter to
	 * @type {number} cashAccountId (int64)
	 */
	cashAccountId;
	/**
	 * @type {number} newMeterAmount
	 */
	newMeterAmount;

	/**
	 * Instantiates a new instance of VgtSetMeterRequest based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {VgtSetMeterRequest}
	 */
	static create(genericObject) {
		const newVgtSetMeterRequest = new VgtSetMeterRequest();
		newVgtSetMeterRequest.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newVgtSetMeterRequest;
	}

	/**
	 * Instantiates a new array of VgtSetMeterRequest based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[VgtSetMeterRequest]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newVgtSetMeterRequestArray = [];
		genericArray.forEach(genericObject => {
			newVgtSetMeterRequestArray.push(VgtSetMeterRequest.create(genericObject));
		});
		return newVgtSetMeterRequestArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('cashAccountId', 'integer'),
	ModelBaseClass.createModelProperty('newMeterAmount', 'float'),
];

export default VgtSetMeterRequestBase;
